<template>
  <div id="PlusGuestReservation_main">
    <p class="title">
      訪客搜尋
    </p>
    <guest-search
      :guest-cause-list="guestCauseList"
      :is-clear-empty="true"
      :re-search="reSearch"
      @onSearch="handleSearch"
    />
    <!-- 即將抵達訪客列表 列表區塊 -->
    <p class="title table-title">
      已預約的訪客
    </p>
    <el-table
      v-horizontal-scroll="'always'"
      :data="listData"
      empty-text="目前無訪客紀錄"
      tooltip-effect="dark"
    >
      <el-table-column
        prop="CauseTypeName"
        label="訪客事由"
      />
      <el-table-column
        prop="TabletNote"
        label="拜訪戶別"
      />
      <el-table-column
        prop="GuestName"
        label="訪客／廠商名稱"
      />
      <el-table-column
        prop="CellPhone"
        label="電話號碼"
      />
      <el-table-column
        v-if="qrcodeEnable.app"
        label="門禁QRcode"
      >
        <template
          v-if="scope.row.QRcode"
          slot-scope="scope"
        >
          <el-badge
            v-if="scope.row.QRcode.QRcodeBadge"
            is-dot
          >
            <span
              v-if="scope.row.QRcode"
              class="detail"
              @click="openGuestQRCodeDialog(scope.$index,scope.row.QRcode)"
            >查看門禁</span>
          </el-badge>
          <span
            v-else
            class="detail"
            @click="openGuestQRCodeDialog(scope.$index,scope.row.QRcode)"
          >查看門禁</span>
        </template>
      </el-table-column>
      <el-table-column
        label="詳細資訊"
        min-width="50"
      >
        <template slot-scope="scope">
          <el-tooltip
            v-if="( scope.row.LicensePlateNumber !== null && scope.row.LicensePlateNumber !== '') || (scope.row.Remark !== null && scope.row.Remark !== '')"
            placement="top"
          >
            <div slot="content">
              <p>車牌：{{ scope.row.LicensePlateNumber || '無' }}</p>
              <p>備註：{{ scope.row.Remark || '無' }}</p>
            </div>
            <i
              class="icon-info info"
              aria-hidden="true"
            />
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        label="預計抵達時間"
        min-width="90"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.BookGuest !== null">{{ scope.row.BookGuest.EstimatedTimeOfArrival }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="訪客抵達"
        width="350"
      >
        <template slot-scope="scope">
          <template v-if="scope.row.CancelInfo">
            <template v-if="scope.row.CancelInfo.AdminInfo && scope.row.CancelInfo.AdminInfo.UserName">
              <p class="cancel-msg">
                {{ $newFormatDate(scope.row.CancelInfo.CreateAt).slice(0,16) }} 管理員取消登記
              </p>
              <p class="cancel-msg">
                (管理員 : {{ scope.row.CancelInfo.AdminInfo.UserName }})
              </p>
            </template>
            <template v-else>
              <p class="cancel-msg">
                {{ $newFormatDate(scope.row.CancelInfo.CreateAt).slice(0,16) }} 住戶取消登記
              </p>
            </template>
          </template>
          <template v-else>
            <el-button
              size="mini"
              type="primary"
              plain
              @click="openGuestArriveDialog(scope.row.Id, scope.row.QRcode)"
            >
              確認訪客抵達
            </el-button>
            <el-button
              size="mini"
              type="danger"
              plain
              @click="handleCancelReserve(scope.row.Id)"
            >
              取消訪客預約
            </el-button>
            <el-button
              size="mini"
              class="btn"
              plain
              @click="openEditDialog(scope.row)"
            >
              修改
            </el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <TableLoading :is-loading="loading" />
    <GuestArriveDialog
      ref="GuestArriveDialog"
      :qrcode-enable-web="qrcodeEnable.web"
      @getList="init"
    />
    <GuestQRCodeDialog
      ref="GuestQRCodeDialog"
      @changeqrcode="changeQRcode"
    />
    <GuestDataCheck
      ref="GuestDataCheck"
      @siteGuestArrived="siteGuestArrived"
    />

    <GuestEditDialog
      :open="editDialogSetting.open"
      :edit-data="editDialogSetting.editData"
      :guest-cause-list="guestCauseList"
      :qr-code-enable-app="qrcodeEnable.app"
      @onClose="closeEditDialog"
      @onEditFinish="handleEditFinish"
    />
  </div>
</template>

<script>
import TableLoading from '@/components/TableLoading'
import GuestArriveDialog from '../components/GuestArriveDialog'
import GuestQRCodeDialog from '../components/GuestQRCodeDialog'
import GuestDataCheck from '../components/GuestDataCheck'
import GuestSearch from '../components/GuestSearch'
import GuestEditDialog from '../components/GuestEditDialog.vue'
import { createBroadcastChannel } from '@/js/utils/broadcastChannelHelper'
import { confirmGuestReservationStatus } from '@/js/utils/guest'

export default {
  components: {
    GuestArriveDialog,
    GuestQRCodeDialog,
    GuestDataCheck,
    TableLoading,
    GuestSearch,
    GuestEditDialog
  },
  props: {
    qrcodeEnable: Object,
    guestCauseList: Array // 訪客事由列表
  },
  data () {
    return {
      listData: [],
      offset: 0,
      loading: false,
      scrollEnd: false,
      guestArrivedIndex: 0,
      canClickButton: true, // 防止連點button參數
      reSearch: false,
      editDialogSetting: {
        open: false,
        editData: {}
      },
      searchQuery: {},
      guestChannel: null // 訪客登記廣播頻道
    }
  },
  mounted () {
    if (this.$route.params.guestId !== 'List') {
      // 顯示收到瀏覽器推播訪客登記流程
      this.$refs.GuestDataCheck.openDialog(this.$route.params.guestId)
    } else {
      // 正常顯示即將抵達列表
      this.first()
    }
    window.addEventListener('scroll', this.autoShow, true)

    // 處理廣播頻道的訊息
    const handleGuestMessage = (event) => {
      const { type, data = {} } = event.data || {}
      const delay = data.delay || 0
      if (type === 'newReservation' || type === 'reload') {
        setTimeout(() => {
          this.init()
        }, delay)
      }
    }
    // 設定廣播頻道
    this.guestChannel = createBroadcastChannel('guest', handleGuestMessage)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.autoShow, true)
    if (this.guestChannel) {
      this.guestChannel.destroy()
    }
  },
  methods: {
    async first () {
      this.loading = true
      this.offset = 0
      this.listData = []
      await this.getList()
    },
    init () {
      this.offset = 0
      this.listData = []
      this.getList()
    },
    getList (queryData = this.searchQuery) {
      this.loading = true
      const requestData = {
        Offset: this.offset,
        MaxCount: 10,
        ...queryData
      }
      return apiGuest.PlusGuestReservation.GetBookGuest(
        requestData
      ).then(async (res) => {
        if (res.status === 200) {
          const now = new Date()
          this.listData = this.offset === 0 ? [] : this.listData
          await this.$sleep(1000, res.duration)
          res.data.forEach(row => {
            if (row.BookGuest !== null) { row.BookGuest.EstimatedTimeOfArrival = this.$newFormatDate(row.BookGuest.EstimatedTimeOfArrival).slice(0, 16) }
            // 判斷是否需要顯示「查看門禁」旁的紅點
            if (row.QRcode !== null && row.QRcode.DueAt) {
              let dueAt = this.$newFormatDate(row.QRcode.DueAt)
              dueAt = new Date(dueAt).getTime()
              row.QRcode.QRcodeBadge = now > dueAt
            }
            this.listData.push(row)
          })
        }
        this.loading = false
        this.scrollEnd = res.data.length < 10
        this.reSearch = false
        return true
      }).catch((err) => {
        this.loading = false
        this.reSearch = false
        console.log('錯誤訊息：', err.response)
        return false
      })
    },
    // click[確認訪客抵達]  開啟訪客押件和門禁卡彈窗
    async openGuestArriveDialog (id, QRcode) {
      if (this.canClickButton) {
        this.canClickButton = false
        this.$refs.GuestArriveDialog.guestArrive(id, QRcode)
        setTimeout(() => {
          this.canClickButton = true
        }, 2000)
      }
    },
    // 開啟 查看門禁 彈窗
    openGuestQRCodeDialog (index, QRcodeData) {
      this.guestArrivedIndex = index
      const guestQRCodeData = {
        guestId: QRcodeData.GuestId,
        code: QRcodeData.Code,
        startAt: QRcodeData.StartAt,
        dueAt: QRcodeData.DueAt
      }
      this.$refs.GuestQRCodeDialog.openDialog(guestQRCodeData)
    },
    // 置換 重新取得門禁QRCode後的時間與badge
    changeQRcode (data) {
      console.log('changeqrcode', data)
      console.log(this.listData[this.guestArrivedIndex])
      this.listData[this.guestArrivedIndex].QRcode.Code = data.code
      this.listData[this.guestArrivedIndex].QRcode.StartAt = data.startAt
      this.listData[this.guestArrivedIndex].QRcode.DueAt = data.dueAt
      this.listData[this.guestArrivedIndex].QRcode.QRcodeBadge = false
      console.log(this.listData[this.guestArrivedIndex])
    },
    // 現場訪客 填寫完表單 開啟訪客押件和門禁卡彈窗
    siteGuestArrived (guestId) {
      const QRcode = null
      this.$refs.GuestArriveDialog.guestArrive(guestId, QRcode)
    },
    // 下拉到底自動載入
    autoShow () {
      const ScrollTop = document.documentElement.scrollTop
      const ClientHeight = document.documentElement.clientHeight
      const ScrollHeight = document.documentElement.scrollHeight
      // eslint-disable-next-line eqeqeq
      if ((ScrollTop + ClientHeight >= ScrollHeight - 20) && !this.loading && this.$router.currentRoute.name == 'PlusGuestReservation') {
        if (!this.scrollEnd) {
          this.offset += 10
          this.$handleScroll(this.getList)
        }
      }
    },
    async handleSearch (searchValue) {
      // 搜尋 並更新清單
      this.offset = 0
      this.searchQuery = searchValue
      this.scrollEnd = false

      await this.getList()
    },
    fullScreenLoading (display) {
      const loadingWrap = this.$loading({
        lock: true,
        text: '資料處理中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      if (!display) {
        loadingWrap.close()
      }
    },
    async handleCancelReserve (cancelId) {
      const isFinished = await confirmGuestReservationStatus(cancelId)
      if (isFinished) {
        this.guestChannel.postMessage({ type: 'deleteItem', data: { id: cancelId } }) // 刪除推播項目
        this.init()
        return
      }

      await this.$confirm('該筆訪客登記取消後將無法還原。您確定要取消嗎？', '是否要取消訪客登記？', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.fullScreenLoading(true)

        await apiGuest.PlusGuestReservation.PostCancelBooked(
          { id: cancelId },
          { 'content-type': 'application/json-patch+json' }
        ).then(() => {
          this.$message({
            message: '訪客登記已取消成功',
            type: 'success'
          })
          this.guestChannel.postMessage({ type: 'deleteItem', data: { id: cancelId } }) // 刪除推播項目
          this.guestChannel.postMessage({ type: 'reload' }) // 使其他頁面重新整理
        }).catch(err => {
          this.$message({
            message: '取消訪客登記失敗，請稍候再試',
            type: 'warning'
          })
        })

        // 更新列表(若有搜尋過,則續用搜尋條件)
        this.reSearch = true
      }).catch((e) => {})

      this.fullScreenLoading(false)
    },
    handleEditFinish () {
      // 關閉彈窗,清空
      this.closeEditDialog()

      // 更新列表(若有搜尋過,則續用搜尋條件)
      this.reSearch = true
    },
    async openEditDialog (editRow) {
      const isFinished = await confirmGuestReservationStatus(editRow.Id)
      if (isFinished) {
        this.guestChannel.postMessage({ type: 'deleteItem', data: { id: editRow.Id } }) // 刪除推播項目
        this.init()
        return
      }

      const qrCodeInfo = editRow.QRcode
        ? {
          startAt: this.$newFormatDate(editRow.QRcode.StartAt),
          dueAt: this.$newFormatDate(editRow.QRcode.DueAt)
        }
        : null

      const editData = {
        id: editRow.Id,
        causeTypeName: editRow.CauseTypeName,
        guestName: editRow.GuestName,
        guestNameVendor: '', // 手機登記只有訪客名稱沒有廠商
        cellphone: editRow.CellPhone,
        licensePlateNumber: editRow.LicensePlateNumber,
        estimatedTimeOfArrival: editRow.BookGuest.EstimatedTimeOfArrival,
        memo: editRow.Remark,
        tabletNote: editRow.TabletNote,
        qrCode: qrCodeInfo
      }
      this.editDialogSetting.editData = editData
      this.editDialogSetting.open = true
    },
    closeEditDialog () {
      // 清空編輯資料
      this.editDialogSetting.open = false
      this.editDialogSetting.editData = {}
    }

  }
}
</script>

<style lang="sass" scoped>
#PlusGuestReservation_main
  color: $subFontColor
  .title
    color: $mainFontColor
    text-align: left
    font-size: 15px
    font-weight: bold
    line-height: 50px
  .table-title
    margin-top: 20px
    margin-bottom: 15px
  ::v-deep .el-table
    +basicTable
    .el-table__row
      height: 58px
    .detail
      color: $mainColor
      border-bottom: 1px $mainColor solid
      cursor: pointer
    .info
      color: #999
      font-size: 22px
    .el-badge__content
      top: 11px
      background-color: $warnColorHover
      right: -5px
      border: 0
    .cancel-msg
      text-align: right
</style>
